import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '@zillow/constellation';

const propTypes = {
    message: PropTypes.string,
};

const defaultProps = {
    message: 'No data available.',
};

const GraphEmptyMessage = ({ message }) => <Text fontType="h6" as="div">{message}</Text>;

GraphEmptyMessage.propTypes = propTypes;
GraphEmptyMessage.defaultProps = defaultProps;

export default GraphEmptyMessage;
